import { SVGProps } from "react";

export function ArrowLeftCircleWrapped(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_d_11471_31108)">
        <circle cx="34" cy="26" r="22" fill="#E6EBF3" />
        <path
          d="M36.6797 17.9512L30.2407 24.3902L36.6797 30.8292"
          stroke="#063982"
          strokeWidth="1.60976"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_11471_31108"
          x="0"
          y="0"
          width="68"
          height="68"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_11471_31108"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11471_31108" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11471_31108"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
